import { Button } from "./Button";
import { Sheet } from "./Sheet";

interface LeaveSessionSheetProps {
  answeredCount: number;
  remainingCount: number;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * S09vAbandon — leads with what is **saved**, not with a warning.
 *
 * A student leaving mid-session is usually out of time or data, not careless.
 * "Are you sure? You'll lose your progress" would be both frightening and
 * false: answers are saved per question and the streak already counts.
 */
export function LeaveSessionSheet({
  answeredCount,
  remainingCount,
  onStay,
  onLeave,
}: LeaveSessionSheetProps) {
  return (
    <Sheet
      title="Leave this session?"
      onDismiss={onStay}
      actions={
        <>
          <Button onClick={onStay}>Keep practicing</Button>
          <Button variant="ghost" onClick={onLeave}>
            Leave — save my progress
          </Button>
        </>
      }
    >
      {/*
        Leaving sends the answers given so far, so "saved" is a fact rather
        than reassurance. The original copy also promised the remaining
        questions "will be waiting" — there is no resume, and a set drawn at
        random is never the same set twice, so that sentence would have been a
        small lie at the exact moment a student is deciding to trust us.
      */}
      <p className="tabular m-0 text-[13.5px] leading-[1.55] text-text-muted">
        Your {answeredCount} answers are saved and your streak still counts. The other{" "}
        {remainingCount} are still in the bank whenever you come back.
      </p>
    </Sheet>
  );
}
